import React from 'react'
import { createRoot } from 'react-dom/client'
import { ChaptersTable } from './components/ChaptersTable'

// Mount point: <div id="…"> plus a <script type="application/json" id="…"> holding the table's data
// (course/templates/progress.section.chapters.htm), so nothing is interpolated into JS
export const startProgressChapters = (elementId, dataId) => {
  const data = JSON.parse(document.getElementById(dataId).textContent)
  createRoot(document.getElementById(elementId)).render(
    <ChaptersTable data={data} />
  )
}
